/**
 * Platform role vocabulary for feature-flag targeting.
 *
 * Mirrors `account-management-app/src/lib/platformRoles.ts` so both frontends
 * put the same value in the same Unleash context property; the platform
 * convention is a singular `platformRole` carrying the hyphenated key, which is
 * what the `role-platform-admin` segment (`platformRole IN [platform-admin]`)
 * matches on.
 *
 * This asks for the admin role by name rather than inferring staffness from a
 * non-empty `platform_roles` claim, which is what the retired
 * `useIsPlatformStaff` hook did (task 692 replaced its call sites with
 * cohort-gated flags). Flag targeting needs the specific role key.
 */

export const PLATFORM_ADMIN_ROLE = 'platform-admin';

// Task 694 removed the transitional tolerance for the underscore spelling
// `platform_admin`. The role-catalog migration is applied in prd — verified in
// the database and in a live token-claims response before the removal — so
// `platform-admin` is the only spelling the platform issues.

/** True when the given platform_roles claim grants the platform admin role. */
export const isPlatformAdminRole = (platformRoles: string[] | undefined): boolean =>
  (platformRoles ?? []).includes(PLATFORM_ADMIN_ROLE);
